import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzGridModule } from 'ng-zorro-antd/grid';

import { LotIconsModule } from '../../shared-components/lot-icons/lot-icons.module';
import { GuideModule } from '../../shared-components/guide/guide.module';

import { AutoLotGuideIconsComponent } from './auto-lot-guide-host/auto-lot-guide-icons.component';
import { AutoLotGuideService } from './services/auto-lot-guide.service';

@NgModule({
  declarations: [AutoLotGuideIconsComponent],
  imports: [CommonModule, TranslateModule, NzGridModule, LotIconsModule, GuideModule],
  exports: [AutoLotGuideIconsComponent],
  providers: [AutoLotGuideService],
})
export class AutoLotGuideModule {}
